<template>
    <div v-if="showNotificationPopup" class="preview-video-popup">
      <b-modal
          id="preview-notification-popup-modal"
          body-class="model-body"
          centered
          content-class="model-content"
          hide-footer
          hide-header
          no-close-on-backdrop
          visible
      >
      <div v-if="!permissionDenied" class="preview-popup-container">
      <b-row class="m-0 mt-2 justify-content-center">
        <h5>Subscribe to Notifications</h5>
      </b-row>
      <b-row class="m-0 mt-2 justify-content-center text-center">
        <p>Get workout reminders, new feature updates, new achievement updates, and more!</p>
      </b-row>
      <b-row class="m-0 mt-2 justify-content-center">
        <b-form-group >
          <b-form-checkbox
            id="checkbox-allow-notification"
            v-model="dontAskAgain"
            name="dontAskAgain"
            :value="true"
            :unchecked-value="false"
            class="show-name-checkbox"
          >
            <span class="font-weight-500 text-gray font-size-16 line-height-24"
              >Don't Ask Again</span
            >
          </b-form-checkbox>
        </b-form-group>
        <b-button class="allow-button" variant="link" @click="allowNotifications">
          Allow
        </b-button>
        <b-button class="cancel-button" variant="link" @click="denyNotifications">
          Don't Allow
        </b-button>
      </b-row>
    </div>
    <div v-if="permissionDenied" class="preview-popup-container">
      <b-row class="m-0 mt-2 justify-content-center">
        <h4>Permission not available</h4>
      </b-row>
      <b-row class="m-0 mt-2 justify-content-center text-center font-size-large">
        <p>You have previously denied notification permission.</p>
      </b-row>
      <b-row class="m-0 mt-2 justify-content-center text-center">
        <p>To enable or re-enable web push notifications, start by accessing your browser's settings or preferences menu from the toolbar. Navigate to sections like Privacy, Security, or Site Settings, and find the Notifications settings within the privacy or site settings section. From there, locate the website under Blocked or Permissions, and adjust the setting to Allow.</p>
      </b-row>
      <b-row class="m-0 mt-2 justify-content-center"><b-button class="cancel-button" variant="link" @click="closePopUp">
          Close
        </b-button></b-row>
    </div>
      </b-modal>
    </div>
  </template>
  <script>

import moment from "moment";
import userService from "../module_user/api/user-service";
import { mapState } from 'vuex';
  export default {
    name: "InstallPwa",
    data() {
      return {
        showNotificationPopup: false,
        permissionDenied : false,
        dontAskAgain : false
      }
    },
    computed: {    ...mapState(["userInfo"]),
    },
    methods: {
        async allowNotifications() {
            if (!('Notification' in window)) {
              this.$bvToast.toast("This browser does not support notifications.", {
                variant: "danger",
                headerClass: "toast__header",
                toaster: "b-toaster-top-center",
                solid: true,
                appendToast: true,
              });
              this.closePopUp()
              return;
            }

            Notification.requestPermission().then(async permission => {
            if (permission === 'granted') {
                this.$emit('setupNotifications');
                this.showNotificationPopup = false
                this.permissionDenied = false
            } else {
                console.log("permission denied")
                this.permissionDenied = true
            }
      });
      },
      async denyNotifications() {
      try {
        await userService.updateUserNotificationStatus({ isNotificationAllowed: false });
      } catch (error) {
        console.error("Failed to update notification status:", error);
      } finally {
        this.showNotificationPopup = false;
        localStorage.setItem("notificationDeniedTime", new Date().toISOString());

        if (this.dontAskAgain) {
          localStorage.setItem("dontAskAgainForNotification", true);
        }
      }
    },
      closePopUp(){
        this.showNotificationPopup=false
        this.permissionDenied = false
      }
    },
    watch: {
    userInfo(userDataNew, userDataOld) {

      const lastNotificationDeniedAt = localStorage.getItem("notificationDeniedTime")

      const permenantlyDenied = localStorage.getItem("dontAskAgainForNotification")

      const timePassedInHours =lastNotificationDeniedAt ? moment().diff(moment(lastNotificationDeniedAt),'h') : null

      if (userDataNew?.userId && !userDataOld?.userId && !userDataNew.isNotificationAllowed && !permenantlyDenied && (timePassedInHours > 2 || !lastNotificationDeniedAt)) {
        this.showNotificationPopup = true
      }
    },
  },
  }
  </script>
  <style lang="scss" scoped>
#preview-notification-popup-modal{
  display: flex !important;
  align-items: center !important; 
  justify-content: center !important
}

::v-deep .model-content {
  width: auto !important;
  margin: auto;
  border: none !important;

  .model-body {
    padding: 0;
  }
}

::v-deep .custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-color: #73BC44 !important;
  border-radius: 4px;
  width: 1rem !important;
  height: 1rem !important;
  left: -1.5rem !important;
}

::v-deep .custom-checkbox .custom-control-input:checked~.custom-control-label::before {
  left: -1.5rem !important;
  width: 1rem !important;
  height: 1rem !important;
}

.preview-popup-container {
  position: relative;
  width: 570px;
  max-width: 90vw;
  height: auto;
  margin: auto;
  padding: 8px;
  border-radius: 15px;
  overflow: hidden;

  .form-group{
    margin-bottom: 0%;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .allow-button{
    width: auto !important;
    background-color: #73BC44 !important;    
    border-radius: 25px;
    color: #ffffff !important;
    font-weight: 600;
    margin-right: 10px
  }
  .cancel-button {
        background-color: red;      
        width: auto;
        color: #ffffff ;
        border-radius: 25px;
        font-weight: 600 ;
      }

}
  </style>
  